import React from 'react';
import { AdminSection } from '../types';
import './AdminSidebar.css';

interface AdminSidebarProps {
  activeSection: AdminSection;
  onSectionChange: (section: AdminSection) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

interface NavItem {
  id: AdminSection;
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  { id: 'overview', label: 'Overview', icon: '📊' },
  { id: 'games', label: 'Games', icon: '🎮' },
  { id: 'users', label: 'Users', icon: '👥' },
  { id: 'user-management', label: 'User Management', icon: '👤' },
  { id: 'analytics', label: 'Analytics', icon: '📈' },
  { id: 'costs', label: 'Costs', icon: '💰' },
  { id: 'system', label: 'System', icon: '🔧' },
];

export const AdminSidebar: React.FC<AdminSidebarProps> = ({
  activeSection,
  onSectionChange,
  isCollapsed,
  onToggleCollapse,
}) => {
  return (
    <aside className={`admin-sidebar ${isCollapsed ? 'admin-sidebar--collapsed' : ''}`}>
      <button
        className="admin-sidebar__toggle"
        onClick={onToggleCollapse}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? '☰' : '✕'}
      </button>

      <nav className="admin-sidebar__nav">
        {navItems.map(item => (
          <button
            key={item.id}
            className={`admin-sidebar__item ${activeSection === item.id ? 'admin-sidebar__item--active' : ''}`}
            onClick={() => {
              onSectionChange(item.id);
              // Auto-collapse on mobile after selection
              if (window.innerWidth < 768) {
                onToggleCollapse();
              }
            }}
            title={item.label}
          >
            <span className="admin-sidebar__item-icon">{item.icon}</span>
            {!isCollapsed && (
              <span className="admin-sidebar__item-label">{item.label}</span>
            )}
          </button>
        ))}
      </nav>
    </aside>
  );
};
